<template>
  <div class="project-app"> 
    <My-new-nav ref="header"></My-new-nav>
      <div class="project-info">
        <div class="project-item">
          <div class="product-img"><img class="img1" src="../../../assets/image/product/cistanche/project.png" alt="苁蓉-数字化运营平台"></div>
          <div class='flexColFirCen'>
            <div class="project-name margin-top-45">苁蓉-数字化运营平台</div>
            <div class="product-description">「苁蓉-数字化运营平台」简单易用的医疗行业项目管理平台，全方位解决医生、服务商、药厂管理痛点，降低整合成本，合规处理业务，提高工作效率，加速项目进程。</div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <ecn-title title="构建学科数字化协同管理平台"></ecn-title>
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/cistanche/model1.png" alt="项目管理"></div>
            <div class='flexColCen2'>
              <div class="project-name">项目管理</div>
              <div class="product-description">对于项目进度进行实时跟踪，项目从立项-执行-交付-结题报告，建立全生命周期的完整证据链留存，方便审计进行穿透式核查，避免纸质资料丢失损坏的风险。</div>
            </div>
          </div>
        </div>
        <div class="project-item">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/cistanche/model2.png" alt="结算单管理"></div>
            <div class='flexColCen2'>
              <div class="project-name">结算单管理</div>
              <div class="product-description">查看电子结算单明细，交付物数量及具体金额；方便合规和财务部在线审核交付物数量和质量；实现在线审批，加快项目交付速度和进程。</div>
            </div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/cistanche/model3.png" alt="电子签章"></div>
            <div class='flexColCen2'>
              <div class="project-name">电子签章</div>
              <div class="product-description">通过线上电子签章，缩短双方内部沟通成本，提升双方沟通效率，提升项目的交付和审核速度，实现高效合作。</div>
            </div>
          </div>
        </div>
        <div class="project-item">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/cistanche/model4.png" alt="数据看板"></div>
            <div class='flexColCen2'>
              <div class="project-name">数据看板</div>
              <div class="product-description">对于数据多维度分析，助于企业优化运营决策，提升ROI，为营销、管理、财务作强有力支撑。同时数据权限隔离，权责明确。</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'project-app-mobile',
    data(){
        return{
            
        }
    },
    mounted(){
       
    },
    methods: {
       
    } 
}
</script>

<style lang="scss" scoped>
  .project-app{
    // font-family: SourceHanSansCN-Regular;
    padding-top: 120px;
    div{
      box-sizing: border-box;
    }
    .margin-top-45{
      margin-top: 45px;
    }
    .project-item{
      width: 100%;
      padding: 120px 36px;
      &:first-child{
        padding-top: 0;
      }
    }
    .project-name{
      font-family: YouSheBiaoTiHei;
      color: #212121;
      line-height: 90px;
      margin-bottom: 33px;
      font-size: 90px;
    }
    .product-description{
      font-weight: 400;
      font-size: 42px;
      color: #212121;
      // font-family: PingFangSC-Regular, PingFang SC;
      line-height: 72px;
      text-align: justify;
    }
    .model-item{
      .project-name{
        font-size: 54px;
        line-height: 54px;
      }
    }
    .flexColFirCen{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .flexColCen2{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .product-img{
      display: flex;
      justify-content: center;
      width: 100%;
      img{
        display: block;
      }
      .img1{
        width: 93.65%;
        max-width: 952px;
        margin: 60px 0;
      }
      .img2345{
        width: 83.33%;
        max-width: 848px;
      }
    }
    .ecn-title ::v-deep {
      margin-bottom: 120px;
      .title{
        font-size: 54px;
        line-height: 54px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        color: #333;
        letter-spacing: 3px;
      }
      .line{
        width: 84px;
        height: 18px;
        margin-top: 24px;
      }
    }
    .bg-gray{
      background-color: #F9F9FD;
    }
  }
</style>